<template>
    <div class="flex gap-2 mt-4 text-sm text-gray-600 md:flex-row flex-col md:items-center md:gap-4">
        <div class="flex items-center gap-2">
            <span class="flex items-center justify-center size-4 rounded border border-teal-400 bg-white">
                <Icon name="check" size="xs" class="text-green-500" />
            </span>
            {{ $t('Available') }}
        </div>
        <div class="flex items-center gap-2">
            <span class="flex items-center justify-center size-4 rounded border bg-emerald-200 border-emerald-500">
                <Icon name="check" size="xs" class="text-green-500" />
            </span>
            {{ $t('Selected') }}
        </div>
        <div class="flex items-center gap-2">
            <span class="flex items-center justify-center size-4 rounded border border-gray-200 bg-gray-100">
                <span class="dp--day-status dp--day-unavailable"></span>
            </span>
            {{ $t('Unavailable') }}
        </div>
    </div>
    <p class="text-sm text-gray-600 mt-2 mb-0">{{ $t('Arrival and departure are only possible on the days marked in green. Your stay may also include the days marked in white.') }}</p>
</template>
